import styled from 'styled-components';
import { body2, captionLink, caption as captionStyles, colors, fontSizes, spacing } from 'ui/theme';

export const CaptionLink = styled.a`
  ${captionLink};
  display: inline-flex;

  > * + * {
    margin-left: ${spacing.quarter};
  }
`;

export const FormBodyText = styled.p`
  ${body2};
  margin: 0; /** default margin causes text to be off-center */
`;

export const ExpandableToggleContent = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacing.threeEights};
  flex-wrap: wrap;
`;

export const Caption = styled.div`
  ${captionStyles};
  font-size: ${fontSizes.s14};
  color: ${colors.textSecondary};
  margin-bottom: ${spacing.base};
`;

export const LabelIconWrapper = styled.span`
  display: inline-flex;
  align-items: flex-start;
  margin-top: 2.5px;
  margin-right: 7.5px;
`;
